class ListIntersectionObserver extends HTMLElement {
  connectedCallback() {
    if (!('IntersectionObserver' in window)) return;

    const selector = this.getAttribute('items') || '.grid__item';
    const items = this.querySelectorAll(selector);

    if (!items.length) return;

    this.remaining = items.length;
    this.observer = new IntersectionObserver(this.#onIntersection.bind(this), {
      rootMargin: '600px 0px',
    });

    for (const item of items) {
      this.observer.observe(item);
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  #onIntersection(entries, observer) {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      for (const img of entry.target.querySelectorAll('img[loading="lazy"]')) {
        img.loading = 'eager';
      }

      observer.unobserve(entry.target);
      this.remaining -= 1;
    }

    if (this.remaining <= 0) observer.disconnect();
  }
}

customElements.define('list-intersection-observer', ListIntersectionObserver);
